import { render, staticRenderFns } from "./counter.pug?vue&type=template&id=309df8c2&scoped=true&lang=pug&"
import script from "./counter.js?vue&type=script&lang=js&"
export * from "./counter.js?vue&type=script&lang=js&"
import style0 from "./counter.scss?vue&type=style&index=0&id=309df8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309df8c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309df8c2')) {
      api.createRecord('309df8c2', component.options)
    } else {
      api.reload('309df8c2', component.options)
    }
    module.hot.accept("./counter.pug?vue&type=template&id=309df8c2&scoped=true&lang=pug&", function () {
      api.rerender('309df8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/counter/index.vue"
export default component.exports